const PAID_LEAVE_MISC = 'paidLeave'
const PAID_FAMILY_MEDICAL_LEAVE = 'paidFamilyMedicalLeave'
const PAID_SICK_LEAVE = 'paidSickLeave'

module.exports = Object.freeze({
  PAID_LEAVE_MISC,
  PAID_FAMILY_MEDICAL_LEAVE,
  PAID_SICK_LEAVE,
  PAID_LEAVE_TYPES: [PAID_LEAVE_MISC, PAID_FAMILY_MEDICAL_LEAVE, PAID_SICK_LEAVE]
})
